import { Autocomplete, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './users-filter.module.scss';
import { DriverStatus } from 'enums';
import locale from 'localization';
import { prettifyUserRole, prettifyVehicleStatus } from 'utils/pretty.utils';
import UserRole from 'enums/user-role';

const UsersFilter = ({ filterState, onStatusChange, onRoleChange, onSearchChange, onSearch }) => {
  const onStatusChangeCb = useCallback(
    (name, { value }) => {
      if (onStatusChange) return onStatusChange(value || 'all');
    },
    [onStatusChange]
  );

  const onRoleChangeCb = useCallback(
    (name, { value }) => {
      if (onRoleChange) return onRoleChange(value || 'all');
    },
    [onRoleChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  return (
    <div className={styles.filter}>
      <Field className={styles.status} label="Status">
        <Autocomplete
          name="status"
          value={filterState.status}
          options={[
            { label: locale.all, value: 'all' },
            { label: prettifyVehicleStatus(DriverStatus.Active), value: DriverStatus.Active },
            { label: prettifyVehicleStatus(DriverStatus.Inactive), value: DriverStatus.Inactive }
          ]}
          onChange={onStatusChangeCb}
        />
      </Field>
      <Field className={styles.status} label="Role">
        <Autocomplete
          name="role"
          value={filterState.role}
          options={[
            { label: prettifyUserRole(UserRole.Admin), value: UserRole.Admin },
            { label: prettifyUserRole(UserRole.Approver), value: UserRole.Approver },
            { label: prettifyUserRole(UserRole.Maker), value: UserRole.Maker }
          ]}
          onChange={onRoleChangeCb}
        />
      </Field>
      <Field className={styles.search}>
        <SearchField
          placeholder={'Name, Username'}
          value={filterState.searchKey}
          onChange={onSearchChangeCb}
          onEnter={onSearchCb}
          restrict={false}
        />
      </Field>
    </div>
  );
};

export default UsersFilter;
